var skipInBundleList=[];
var section_prod_info_container = ".product__info-container";
var prod_selected_btnclass="button.noatctitle.product-form__submit";
function addProductInSelection(ctrl){  
	// use this method to add product in list.
  
  	// remove from SKIP list
  	var formid = $(ctrl).closest("form.form").attr("id");
  	var variantid = $(ctrl).closest("form.form").find("[name='id']").val();
  	if($.inArray(formid, skipInBundleList) > -1){
  		skipInBundleList =  skipInBundleList.filter(el => el !== formid);
    }
  
  	addProductsInFinalBlock($(ctrl).closest(".product__info-container").attr("productid"), variantid);
  
  	$(ctrl).addClass("vselected");
  	$(ctrl).find("ttt").html($(ctrl).attr("dt-selectedtext"));
  
  	moveToNextProductSection(ctrl);
            
	return false;  
}

function moveToNextProductSection(ctrl){
  
  	var isfinalblock=false;
	// use this method to add product in list.
  	var ctrlContainer = $(ctrl).closest(section_prod_info_container);
  	
  	var enableIndex=0;
  	var newenabled;
  $(section_prod_info_container).each(function(indexx, ele){ 
        if(enableIndex == indexx){
            makeProductOptionEnable(ele);
          	newenabled = ele;
          
          	if($(ele).hasClass("blockfinalatc"))
            {
                // add table to display final products.
            }
          	
        }
    
      	if($(ctrlContainer).attr("id") == ele.id){          
          enableIndex = indexx + 1;
      	}                                                     
   });
  
  	 $([document.documentElement, document.body]).animate({
                scrollTop: $(ctrlContainer).closest("section.shopify-section").next().offset().top
     }, 500);
          
}
function moveScrollToSection(pid)
{
  	var ctrlContainer = $(section_prod_info_container+"[productid='"+ pid +"']");
	$([document.documentElement, document.body]).animate({
                scrollTop: $(ctrlContainer).closest("section.shopify-section").offset().top - 100
     }, 500);
}

function variantSelectionChangedCustom(ctrl)
{
  	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).removeClass("vselected");
	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).find("ttt").html($(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).attr("dt-btntext"));
  
  	// DISBALE ALL BELOW OPTIONS & update button text.
  
  	/*var ctrlContainer = $(ctrl).closest(section_prod_info_container);
  	var enableIndex=0;
  	var newenabled;
  	$(section_prod_info_container).each(function(indexx, ele){ 
        if(enableIndex == indexx){
            makeProductOptionDisable(ele);
          	
          	$(ele).find(prod_selected_btnclass).removeClass("vselected");  
  			$(ele).find(prod_selected_btnclass).find("ttt").html($(ele).closest(section_prod_info_container).find(prod_selected_btnclass).attr("dt-btntext"));
          
          	newenabled = ele;
        }
    
      	if($(ctrlContainer).attr("id") == ele.id || (newenabled.id == ele.id && indexx > 0) ){ 
          enableIndex = indexx + 1;
      	}
   	});*/
  
  
}
function skipThisProduct(ctrl) {
  	skipInBundleList.push($(ctrl).closest("form.form").attr("id"));
  	moveToNextProductSection(ctrl);
  	
  	// reset Button TEXT.
  	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).removeClass("vselected");  
  	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).find("ttt").html($(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).attr("dt-btntext"));
  return false;
}

function makeProductOptionDisable(elem){
	// Cover this element container'options to untouchable  	
  	$(elem).addClass("overlapcus");
}


function makeProductOptionEnable(elem){
	// Remove disbale state from element.
  	$(elem).removeClass("overlapcus");
}

function addAllSelectedProductsIntoCart(ctrl)
{
  	// Final add to cart button, so do a loop and selected options and add into cart.
  	var ditems = [];
  	tobeCartItem.filter(function(item, indexx){

      // IGNORE SKIP PRESSED ITEMS.
      if($.inArray(item.variantid, skipInBundleList) == -1){
      	var qty = 1;
        if(qty == null)
              qty = 1;
        else{
          qty = parseFloat(qty);
        }
      	
      	ditems.push({ 'id': parseFloat(item.variantid), 'quantity' : qty });
      }         
   	});
  var errEle = $(ctrl).closest(section_prod_info_container).find(".product-form__error-message");
  $(errEle).attr("hidden","");
  
  if($(ctrl).find(".loading-overlay__spinner").hasClass("hidden")){
  	
    $(ctrl).find(".loading-overlay__spinner").removeClass("hidden");
    
  
  	let formData = {
         'items': ditems
        };
  
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(formData)
        })
        .then(response => {
          debugger
          // redirect to cart page
          //window.location = '/cart';
          if(response.status != 200){
          	$(errEle).text("Out of Stock Issue");
          	$(errEle).removeAttr("hidden");
            $(ctrl).find(".loading-overlay__spinner").addClass("hidden");
          }else{
          	window.location = "/cart";
          }
          return response.json();
        })
        .catch((error) => {
          debugger       
          
          $(errEle).text(error);
          $(errEle).removeAttr("hidden")
          $(ctrl).find(".loading-overlay__spinner").addClass("hidden");
          console.error('Error:', error);
        });
  }
  
  return false;
}

function renderSelectedItems() {
    // Extract the product title or handle from the page
    var productTitleElement = document.querySelector('.product__info-container h1');
    var productTitle = productTitleElement ? productTitleElement.textContent.toLowerCase() : '';

    // Loop on products
    var tbodyhtml = $("#itemsSelected tbody");
    tbodyhtml.html('<tr><td colspan="3"><h2>Selected <span style="color:orange">Components</span></h2></td></tr>');

    var discount = 0;
    var subtotal = 0;

    tobeCartItem.filter(function(item, index) {
        var selvid = item.variantid;
        var pd = window.productJson.find(s => s.id == item.productid).vdata.find(v => v.id == selvid);

        var prdname = pd.name;
        var prdprice = pd.price / 100;
        var prdImgUrl = "https://cdn.shopify.com/s/files/1/0099/5882/files/NO-IMAGE.png?v=1654502606";
        if (pd.featured_image != null)
            prdImgUrl = pd.featured_image.src;

        var isDoNotSkip = $(section_prod_info_container + "[productid='" + item.productid + "']").hasClass("donotskip");

        subtotal = subtotal + prdprice;

        var htRow = '<tr class="cart-item builder-table" ><td class="cart-item__media">';
        htRow += '<div class="cart-item__image-container gradient global-media-settings"> <img src="' + prdImgUrl + '" class="cart-item__image" alt="" width="150" height="150"> </div>';
        htRow += '</td><td class="cart-item__details"><a onclick="return moveScrollToSection(' + item.productid + ')" href="javascript:void(0)" class="cart-item__name h4 break">' + prdname + '</a></td>';

        if (isDoNotSkip == false)
            htRow += '<td><a style="color:grey" onclick="return removeItemFrmList(this,' + selvid + ',' + item.productid + ')" href="javascript:void(0)" class="button button--tertiary btnremovesubitem" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" role="presentation" class="icon icon-remove"><path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path><path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path></svg></a></td>';
        else
            htRow += '<td><a class="changelink" onclick="return moveScrollToSection(' + item.productid + ')" href="javascript:void(0)">Change</a></td>';
        htRow += '<td class="right">$' + prdprice.toFixed("2") + '</td></tr>';
        tbodyhtml.append(htRow);

    });

    // Sub total
    var fnRow = '<tr class="right builder-table"><td colspan="4">Sub Total $' + subtotal.toFixed("2") + '</td></tr>';

    // DISCOUNT
    if (productTitle.includes('dragon') && subtotal > 300) {
        discount = subtotal * 0.1;
        fnRow += '<tr class="right builder-table"><td colspan="4">Discount for Kit - $' + discount.toFixed(2) + '</td></tr>';
    } else if (subtotal > 150) {
        discount = subtotal * 0.1;
        fnRow += '<tr class="right builder-table"><td colspan="4">Discount - $' + discount.toFixed(2) + '</td></tr>';
    }

    // TOTAL
    fnRow += '<tr class="right builder-table"><td colspan="4"><b>Total $' + (subtotal - discount).toFixed(2) + '</b></td></tr>';

    tbodyhtml.append(fnRow);
}

function addProductsInFinalBlock(pid, vid) {
    var exists = tobeCartItem.find(s => s.variantid == vid);
    if (exists == null) {

        var sameProductExists = tobeCartItem.find(s => s.productid == pid);
        if (sameProductExists != null) {
            // remove it
            tobeCartItem = tobeCartItem.filter(s => s.productid != pid);
        }

        tobeCartItem.push({ 'productid': pid, 'variantid': vid });
        renderSelectedItems();
    }
}


function removeItemFrmList(ctrlRemove,vid, pid){
	// add variant id into skipList;
  	var ctrl = $(".product__info-container[productid='"+ pid +"'] form.form .product-form__submit");
  	skipInBundleList.push($(ctrl).closest("form.form").attr("id"));
  	// reset Button TEXT.
  	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).removeClass("vselected");  
  	$(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).find("ttt").html($(ctrl).closest(section_prod_info_container).find(prod_selected_btnclass).attr("dt-btntext"));
  
  	tobeCartItem = tobeCartItem.filter(s=>s.variantid != vid);
  	renderSelectedItems();
  
  	return false;
}

var tobeCartItem=[];
var productJson = window.productJson || [];
function addProductVarinatJson(pid, pjson){
  window.productJson.push({"id" : pid, "vdata": pjson});
}

function startDragonBundlePageFuncationality()
{
	//	clear JS loops and variables. 
  	//	Disbale all blocks which have forms and buttons -- EXCEPT first one.
  	$("section.dragonbuild-enabled .product__info-container").addClass("overlapcus");
  	makeProductOptionEnable($("section.dragonbuild-enabled .product__info-container").get(0));  
  
  	// add flag to LAST block to perform as ADD TO CART.
  	$($("section.dragonbuild-enabled .product__info-container").last().find("button.noatctitle")[0]).attr("onclick","return addAllSelectedProductsIntoCart(this)");
  	//$($("section.dragonbuild-enabled .product__info-container").last().find("button.noatctitle")[0]).html("<span>ADD ALL TO CART</span>");
}

$(document).ready(function(){
  if($("section.dragonbuild-enabled").length > 0){
  		startDragonBundlePageFuncationality();
  }

  if(window.countryFindCall == undefined){
    window.countryFindCall = true;
    // For Fusion bundle product - https://www.threeworlds.com.au/products/fusion-collapsible-dragon-staff 
    fetch("https://freeipapi.com/api/json", { "method": "GET" }).then(d=>d.json()).then(s => { if(s.countryCode == "AU"){ document.querySelectorAll(".product-form__input[data-opname='Grip']").forEach(function(item){ item.classList.add("allowedCountry"); }) } } );
  }
  
});